import { http } from 'vue'

export default {
  // load references from the API server
  loadReferences (context, params = {}) {
    return http.get('references' + '?client_id=' + params.client_id)
  },
  // create address at the API server
  postReference (context, params = {}) {
    return http.post('references', params.data)
  },
  // edit address at the API server
  putReference (context, params = {}) {
    return http.put('references/' + params.id, params.data)
  },
  // delete address at the API server
  deleteReference (context, params = {}) {
    return http.delete('references/' + params.id)
  },
  // save references at the store
  saveReferences (context, payload) {
    context.commit('SAVE_REFERENCES', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/references/actions.js